import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { FeatureStackIcon } from './icons/HowElementsExplorerIcons';

interface ElementAttributeTagProps {
  label: string;
  variant: 'feature' | 'tag';
}

export function ElementAttributeTag({ label, variant }: ElementAttributeTagProps): ReactNode {
  const isFeature = variant === 'feature';
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: isFeature ? 'border.light' : 'border.default',
        borderRadius: 1,
        color: isFeature ? 'text.primary' : 'text.secondary',
        display: 'inline-flex',
        flex: '0 1 auto',
        gap: 0.5,
        minWidth: 0,
        px: 1,
        py: 0.5,
      }}
    >
      {isFeature ? (
        <Box sx={{ flexShrink: 0, transform: 'scale(0.85)' }}>
          <FeatureStackIcon />
        </Box>
      ) : (
        <SellOutlinedIcon sx={{ flexShrink: 0, fontSize: 9 }} />
      )}
      <Tooltip title={label}>
        <Typography
          component="span"
          sx={{
            color: 'inherit',
            display: 'block',
            fontSize: 10,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Tooltip>
    </Box>
  );
}
